module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-bg-2-sp-0aa948fcac74c5726cd81b3c7bdf336f.png";